import React, { useContext, useEffect, useState } from "react";
import { TaskGroupCardForTemplate } from "../../../components/ProjectTasks/TaskGroupCardForTemplate";
import "./common.css";
import AddInlineData from "../../../components/ProjectTasks/AddInlineData";
import swal from "sweetalert";
import AppContext from "../../../Context/AppContext";
import BottomBar from "../../../components/ProjectTasks/BottomBar";
import AwsServerService from "../../../common/util/AwsServerService";
import { Button } from "antd";
import { convertToUSTime } from "../../../components/HR/TimeClock/Util";
import { Socket } from "../../../Context/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { canAccess } from "../../../common/util/appUtils";

import {message} from "antd";
import moment from "moment";
import TaskService from "../../../common/util/TaskService";
import { setNotificationFlag } from "../../../Context/ReduxContext";
export default function SubTaskTab({
  taskData,
  allPipelineData,
  module,
  viewTaskFunction,
  groupFilter,
  selectedTable,
  subTaskData,
  setSubTaskData,
  isSubTaskView,
  setIsSubTaskView,
  setPageRefreshData,
  refreshData,
  setOpen,
  allBlueprintsData,
  setTaskData,
  allTasksAndSubtasks,
  dropdownTasksDataCache,
  allDependeniesData,
  setDependencyRefresh,
  setUpdateFlag,
  isTaskModalClosed,
  lookUpDeal
}) {
  const AppData = useContext(AppContext);
  const AppReduxContextDispatch = useDispatch();
  const { state, dispatch } = AppData || {};
  let allAppUsers = state.AllAppUsers || [];
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const getNotification = useSelector((state) => state.AppReduxContext.getNotificationFlag);
  let user = JSON.parse(localStorage.getItem("userinfo"));
  const [isAdding, setIsAdding] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");
  const [selectedIdsForTemp, setSelectedIdsForTemp] = useState({Task:[],Subtask:[]});
  const [selectedIds, setSelectedIds] = useState([]);
  const [subEditData, setSubEditData] = useState({
    id: Date.now(),
    Assignee: "",
    Priority: "",
    CREATEDBY: user.email_id,
    Supervisor: "",
    TaskDescription: "",
    TaskName: "",
    TimeEstimate: "",
    SubTaskROWID: '',
    DueDate: convertToUSTime(new Date()),
    StartDate: convertToUSTime(new Date()),
  });

  useEffect(
    (e) => {
      if (isTaskModalClosed) {
        setSubEditData({
          id: Date.now(),
          Assignee: "",
          Priority: "",
          CREATEDBY: user.email_id,
          Supervisor: "",
          TaskDescription: "",
          TaskName: "",
          TimeEstimate: "",
          DueDate: convertToUSTime(new Date()),
          StartDate: convertToUSTime(new Date()),
          // SubTaskROWID: '',
          PipelineROWID: taskData?.PipelineROWID
        });
        setSelectedIdsForTemp({Task:[],Subtask:[]})
        setIsAdding(false);
      }
    },
    [isTaskModalClosed]
  );

  useEffect(() => {
    if (taskData?.PipelineROWID && isAdding) {
      let updatedSubTaskData = subTaskData.map((item) => {
        return { ...item, PipelineROWID: taskData.PipelineROWID }; 
      });
      // If you want to update a state or pass this data somewhere, you can do it here:
      setSubTaskData(updatedSubTaskData); // Assuming you have a setState function
    }
  }, [taskData?.PipelineROWID, isAdding]);
  
  // console.log("log data", subTaskData);

 const handleAddRow = () => {  
    setIsAdding(true);
    setSubTaskData([...subTaskData, subEditData]);
  };

  useEffect(
    (e) => {
      if (idToDelete) {
        let updatedTasks = [...subTaskData];
        let fileterdData = updatedTasks?.filter(
          (item) => item?.id != idToDelete
        );
        setSubTaskData(fileterdData);
        setIdToDelete("");
        setIsAdding(false);
      }
    },
    [idToDelete]
  );
  const hasAccess = canAccess(accessContext, selectedTable == "Task" ? "Tasks" : "Pipeline Template", "Create");
  // Save the data (simulate API call)
  const handleSave = async() => {  
    // Find the index of the object with the same id in subTaskData
    if(!subEditData?.TaskName){
      swal('Alert','Task Name can not be empty!',"warning")
      return
    }
    let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0];
    let item={...subEditData};
    let data={...subEditData};
    item['TaskFlowObject']=flowObj;
    item['TaskFlowId']=flowObj?.ROWID;
    if(selectedTable=='tasks'){
    if(taskData?.TaskROWID || taskData?.TaskId){
    delete item["id"];
    delete item["flag"];
    delete item["PipelineROWID"];
    item["TaskROWID"] = taskData.TaskROWID;
    item["Status_Time"] = moment.utc().format('YYYY-MM-DD HH:mm:ss');
    item["Priority"] = taskData.Priority ? taskData.Priority : "Not Set";
    await AwsServerService.createSubtask(item).then(async r=>{
      data['SubTaskROWID']=r[0].insertId;
      debugger
      let zuidArr = [];
      let text = '';
        text = (
          <>
            Created Subtask {' '}
            <span style={{ fontWeight: 'bold' , whiteSpace:"nowrap"}}>
              {item.TaskName}
            </span>{' '}
            for Task{' '}
          </>
        );
        zuidArr = [...zuidArr, taskData.Assignee, taskData.Supervisor]
        const renderToHtml = (element) =>
        require('react-dom/server').renderToString(element);
        await TaskService.SendAssignedNotification(zuidArr,allAppUsers,taskData,lookUpDeal,"Task", renderToHtml(text)).then(e=>{
          AppReduxContextDispatch(setNotificationFlag(!getNotification));
        }).catch(e=>{})
      dispatch(Socket({ trigger: "refresh_activity", data: '' }))
      // let text = `<a style="color:#40a9ff" id="User-${
      //   user?.email_id
      // }">${
      //   user?.first_name + " " + user?.last_name
      // }</a> <span> created sub task ${item?.TaskName} in ${taskData.TaskName}</span> `;

      //   await TaskService.SendTaskNotification(
      //     AllUsers,
      //     text,
      //     "Task",
      //     "Task"
      //   ).then(e=>{
      //     getNotification();
      //   }).catch(e=>{
      //     console.log("e", e)
      //   })
    });
  }}else{
    if(taskData?.TaskROWID || taskData?.TaskId){
    delete item["id"];
    delete item["flag"];
    delete item["PipelineROWID"];
    item["TaskROWID"] = taskData.TaskROWID;
    await AwsServerService.createSubtaskInTemplate(item).then(async r=>{
      data['SubTaskROWID']=r[0].insertId;
      dispatch(Socket({ trigger: "refresh_activity", data: '' }))
      // let text = `<a style="color:#40a9ff" id="User-${
      //   user?.email_id
      // }">${
      //   user?.first_name + " " + user?.last_name
      // }</a> <span> created sub task ${item?.TaskName} in ${taskData.TaskName}</span> `;

      //   await TaskService.SendTaskNotification(
      //     AllUsers,
      //     text,
      //     "Task",
      //     "Task"
      //   ).then(e=>{
      //     getNotification();
      //   }).catch(e=>{
      //     console.log("e", e)
      //   })
     })
    }
  }
    // if (subEditData.hasOwnProperty('SubTaskROWID')) {
    //   delete subEditData.SubTaskROWID;
    // }
      
    data["flag"] = true;
    const existingIndex = subTaskData.findIndex(
      (item) => item.id === data.id
    );
    
    if (existingIndex !== -1) { 
      const updatedTaskData = [...subTaskData];
      updatedTaskData[existingIndex] = {
        ...subTaskData[existingIndex],
        ...data,
      };
      setSubTaskData(updatedTaskData);
    } else { 
      setSubTaskData([...subTaskData, data]);
    } 
    setSubEditData({
      id: Date.now(),
      Assignee: "",
      Priority: "",
      CREATEDBY: user.email_id,
      Supervisor: "",
      TaskDescription: "",
      TaskName: "",
      TimeEstimate: "",
      DueDate: convertToUSTime(new Date()),
      StartDate: convertToUSTime(new Date()),
    });

    setIsAdding(false);
  }; 
  return (
    <div className="Subtask-Table">
      <div className="add-row-btn">
        <Button
          // disabled={!pipelineData?.PipelineName}
          onClick={() => {debugger
            if(!hasAccess){
              message.error("Permission Denied")
              return;
            }
            setOpen(true);
            setTaskData();
          }}
          style={hasAccess ? {} : {cursor: "not-allowed", opacity: 0.6,}}
          disabled={!taskData?.TaskROWID || isAdding}
        >
          Add SubTask
        </Button>
      </div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <AddInlineData 
          onAdd={(e) => {
            if(!hasAccess){
              message.error("Permission Denied")
              return;
            }
            handleAddRow(e);
          }}
          onSave={(e) => {
            handleSave();
          }}
          isAdding={isAdding}
          name={"Add SubTask"}
          isAccess= {hasAccess}
        /> 
      {selectedIds.length>0 && <Button onClick={()=>{
       let data=[...subTaskData];
       setSubTaskData(data.filter(e=>!selectedIds.includes(e.id)));
       setIsAdding(prev => !prev);
       setSubEditData({
        id: Date.now(),
        Assignee: "",
        Priority: "",
        CREATEDBY: user.email_id,
        Supervisor: "",
        TaskDescription: "",
        TaskName: "",
        TimeEstimate: "",
        DueDate: convertToUSTime(new Date()),
        StartDate: convertToUSTime(new Date()),
      });
       setSelectedIds([]);
      }}>
        Delete
      </Button>}
      </div>
      <TaskGroupCardForTemplate
        fromSubtaskTab={true}
        editData={subEditData}
        setEditData={setSubEditData}
        module={module}
        taskData={taskData}
        viewTaskFunction={viewTaskFunction}
        groupFilter={groupFilter}
        allPipelineData={allPipelineData}
        data={subTaskData}
        header={"Task Name"}
        selectedTable={selectedTable}
        isSubTaskView={isSubTaskView}
        setIdToDelete={setIdToDelete}
        setIsSubTaskView={setIsSubTaskView}
        setPageRefreshData={setPageRefreshData}
        selectedIdsForTemp={selectedIdsForTemp}
        setSelectedIdsForTemp={setSelectedIdsForTemp}
        setDummyObj={()=>{}}
        dummyObj={{}}
        emptyData={!taskData?.TaskROWID}
        setSelectedIds={setSelectedIds}
        selectedIds={selectedIds}
        setDependencyRefresh={setDependencyRefresh}
        allDependeniesData={allDependeniesData}
        dropdownTasksDataCache={dropdownTasksDataCache}
        allTasksAndSubtasks={allTasksAndSubtasks}
        setUpdateFlag={setUpdateFlag}
      />

    {(selectedIdsForTemp?.Task?.length > 0 || selectedIdsForTemp?.Subtask?.length > 0) && 
          <BottomBar 
            selectedIds={selectedIdsForTemp}
            setSelectedIds={setSelectedIdsForTemp} 
            setPageRefreshData={setPageRefreshData} 
            refreshData={refreshData}
            selectedTable={selectedTable}
            subTaskData={subTaskData}
            setSubTaskData={setSubTaskData}
            allPipelineData={allPipelineData}
            setSubEditData={setSubEditData}
            setIsAdding={setIsAdding}
            setUpdateFlag={setUpdateFlag}
            allTasksAndSubtasks={allTasksAndSubtasks}
            />
        }

    </div>
  );
}
